"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CustomFontOverlay = void 0;
var _CustomDialog = _interopRequireDefault(require("../../../../../Shared/Components/CustomDialog"));
var _i18n = require("../../../../../Framework/i18n");
var _DialogContent = _interopRequireDefault(require("@material-ui/core/DialogContent"));
var _TextField = _interopRequireDefault(require("@material-ui/core/TextField"));
var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));
var _DialogActions = _interopRequireDefault(require("@material-ui/core/DialogActions"));
var _MainButton = _interopRequireDefault(require("../../../../../Shared/Components/MainButton"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styles = require("@material-ui/core/styles");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    contentRoot: {
      margin: '0px auto'
    },
    customFieldWrapper: {
      display: 'flex',
      justifyContent: 'center',
      fontWeight: 'bold',
      marginTop: 24,
      marginBottom: 32
    },
    customFieldInput: _defineProperty({
      fontSize: '15px',
      lineHeight: '18px',
      height: 20,
      padding: '10px 16px',
      minWidth: 320
    }, theme.breakpoints.down('xs'), {
      padding: '0 5px',
      height: 56
    }),
    customField: _defineProperty({
      fontSize: '26px',
      borderRadius: 4,
      height: 40,
      fontWeight: 'bold'
    }, theme.breakpoints.down('xs'), {
      height: 56,
      width: '100%'
    })
  };
}, {
  name: 'CustomFontOverlay'
});
var CustomFontOverlay = exports.CustomFontOverlay = function CustomFontOverlay(props) {
  var open = props.open,
    onClose = props.onClose,
    onApply = props.onApply;
  var _useState = (0, _react.useState)(''),
    _useState2 = _slicedToArray(_useState, 2),
    customFont = _useState2[0],
    changeCustomFont = _useState2[1];
  var classes = useStyles();
  var applyCustomFont = function applyCustomFont(customFont) {
    onApply(customFont);
    changeCustomFont('');
  };
  var closeOverlay = function closeOverlay() {
    onClose();
    changeCustomFont('');
  };
  return open && /*#__PURE__*/_react["default"].createElement(_CustomDialog["default"], {
    open: open,
    onClose: closeOverlay,
    "aria-labelledby": "alert-dialog-title",
    "aria-describedby": "alert-dialog-description",
    onCancel: closeOverlay,
    dialogTitle: (0, _i18n.t)('textControlbox.addCustomFont')
  }, /*#__PURE__*/_react["default"].createElement(_DialogContent["default"], {
    className: classes.contentRoot
  }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    variant: "body1",
    classes: {
      root: classes.TypographyCaption
    },
    id: "alert-dialog-description"
  }, (0, _i18n.t)('textControlbox.infoText')), /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.customFieldWrapper
  }, /*#__PURE__*/_react["default"].createElement(_TextField["default"], {
    classes: {
      root: classes.customField
    },
    value: customFont,
    onChange: function onChange(evt) {
      return changeCustomFont(evt.target.value);
    },
    variant: "outlined",
    inputProps: {
      maxLength: 20
    },
    InputProps: {
      classes: {
        input: classes.customFieldInput
      }
    }
  }))), /*#__PURE__*/_react["default"].createElement(_DialogActions["default"], null, /*#__PURE__*/_react["default"].createElement(_MainButton["default"], {
    onClick: closeOverlay,
    size: "medium",
    fullWidth: true,
    variant: "contained"
  }, (0, _i18n.t)('textControlbox.cancel')), /*#__PURE__*/_react["default"].createElement(_MainButton["default"], {
    onClick: function onClick() {
      return applyCustomFont(customFont);
    },
    size: "medium",
    fullWidth: true,
    variant: "contained"
  }, (0, _i18n.t)('textControlbox.apply')))) || null;
};